module.exports = __webpack_public_path__ + "static/media/amitx.ce64b37f.jpg";